import React, { useState } from "react";
import { Button, Popover, TextField } from "@mui/material";
import { Controller, ControllerRenderProps } from "react-hook-form";
import { DateRange, DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import dayjs from "dayjs";
import styles from "./DateRangeInput.module.scss";

import withLabelAndError from "../withLabelAndError";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";
import CalenderDropdown from "./CalenderDropdown";
import Input from "../Input/Input";

const DateRangeInput: React.FC<InputControlProps> = ({
  control,
  name,
  validations,
  error,
  placeholder,
  className,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePreset = (type: string, onChange: (val: any) => void) => {
    const today = dayjs();
    let from: Date, to: Date;

    switch (type) {
      case "Today":
        from = to = today.toDate();
        break;
      case "Weekly":
        from = today.startOf("week").toDate();
        to = today.endOf("week").toDate();
        break;
      case "Monthly":
        from = today.startOf("month").toDate();
        to = today.endOf("month").toDate();
        break;
      case "Yearly":
        from = today.startOf("year").toDate();
        to = today.endOf("year").toDate();
        break;
      default:
        from = to = today.toDate();
    }
    onChange({ from, to });
  };

  const handleApply = (close: () => void) => {
    close();
  };

  // const handleInputChange =
  //   (
  //     key: "from" | "to",
  //     otherValue: Date | undefined,
  //     onChange: ControllerRenderProps["onChange"]
  //   ) =>
  //   (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const date = e.target.value;
  //     const otherKey = key === "from" ? "to" : "from";
  //     const value = dayjs(date).toDate();
  //     if (dayjs(date).isValid()) {
  //       const temp = {
  //         [key]: value,
  //         [otherKey]: otherValue ?? value,
  //       };
  //       onChange?.(temp);
  //     }
  //   };

  return (
    <Controller
      control={control}
      name={name}
      rules={validations}
      render={({ field: { value, onChange } }) => {
        const range: DateRange = value || {};
        const formatted =
          range.from && range.to
            ? `${dayjs(range.from).format("DD/MM/YYYY")} - ${dayjs(range.to).format("DD/MM/YYYY")}`
            : placeholder || "DD/MM/YYYY - DD/MM/YYYY";

        return (
          <div className={styles.wrapper}>
            <Button
              variant="outlined"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              className={styles.triggerButton!}
              fullWidth
            >
              {formatted}
            </Button>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <div className={styles.popup}>
                <div className={styles.header}>Select Date</div>

                <div className={styles.content}>
                  <DayPicker
                    mode="range"
                    className={styles.dayPicker!}
                    selected={range}
                    onSelect={(val) => {
                      console.log("val", val);
                      onChange(val || {});
                    }}
                    numberOfMonths={1}
                    components={{
                      Dropdown: CalenderDropdown, // 👈 use the dropdown caption
                    }}
                    captionLayout="dropdown"
                    showOutsideDays
                  />

                  <div className={styles.filters}>
                    <h4>Preset Filter</h4>
                    {["Today", "Weekly", "Monthly", "Yearly"].map((f) => (
                      <button
                        key={f}
                        onClick={() => handlePreset(f, onChange)}
                        className={styles.filterBtn}
                      >
                        {f}
                      </button>
                    ))}
                  </div>
                </div>
                <div className={styles.footer}>
                  <div className={styles.rangeInputs}>
                    <Input
                      type="date"
                      name="from"
                      label="From"
                      size="small"
                      value={
                        range.from ? dayjs(range.from).format("YYYY-MM-DD") : ""
                      }
                      // onChange={handleInputChange("from", range.to, onChange)}
                      InputProps={{
                        readOnly: true,
                      }}
                      onClick={(e) => e.preventDefault()}
                    />
                    <Input
                      type="date"
                      name="to"
                      label="To"
                      size="small"
                      value={
                        range.to ? dayjs(range.to).format("YYYY-MM-DD") : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      onClick={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className={styles.actions}>
                    <Button onClick={() => setAnchorEl(null)}>Cancel</Button>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => handleApply(() => setAnchorEl(null))}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              </div>
            </Popover>

            {error && <p className={styles.errorText}>{error.message}</p>}
          </div>
        );
      }}
    />
  );
};

const DateRangeInputWithLabelAndError = withLabelAndError(
  DateRangeInput as WithLabelAndErrorComponent
);

export default DateRangeInputWithLabelAndError;
export { DateRangeInput };
